<template><section class="login-card"><h1>Acceso desde MSP</h1><p role="status">{{ message }}</p><a v-if="failed" href="/msp">Volver al portal MSP</a></section></template>
<script>
import http from 'axios';
import storage from '../api/storage';
export default {
  data: () => ({message:'Abriendo la gestión del restaurante…',failed:false}),
  async mounted() {
    const ticket=this.$route.query.ticket;
    window.history.replaceState(null,'',window.location.pathname+'#/msp-access');
    try {
      const {data}=await http.post(process.env.VUE_APP_API_URL+'/auth/msp-access',{ticket});
      storage.removeItemsSessionStorage();
      storage.saveToken(data.logo,'',data.name,data.nameRestaurant,data.token,data.url);
      storage.saveAuthenticated(true);
      sessionStorage.setItem('br-ca-msp-session','true');
      await this.$router.replace('/Home');
      window.location.reload();
    } catch(error) { this.failed=true; this.message='El acceso ha caducado o el cliente está deshabilitado. Abre de nuevo la gestión desde el portal MSP.'; }
  }
};
</script>
<style scoped>.login-card{max-width:600px;margin:80px auto;padding:24px;background:white;border-radius:16px;}</style>
